import { useEffect } from 'react';

import TradingView from '../../trading-view';
import { clearAllPatterns } from './pattern-utils';

interface Props {
  tv: TradingView | undefined;
}

const Normal = ({ tv }: Props) => {
  useEffect(() => {
    if (!tv) return;
    const initialize = () => {
      clearAllPatterns(tv);
    };

    tv.on('onFirstDataLoaded', initialize);
    return () => tv.off('onFirstDataLoaded', initialize);
  }, [tv]);

  return null;
};

export default Normal;
